export default __webpack_public_path__ + "cross-mark-on-a-black-circle-background.png";